import React from "react";
import Skeleton from "./Skeleton";
import "./loaders.css";

/**
 * Statistic card skeleton (icon + count + label + action placeholder).
 * Renders `count` cards inside the standard dashboard grid columns.
 */
const CardSkeleton = ({ count = 1, withGrid = false }) => {
  const card = (
    <div className="xc-skel-card">
      <div className="d-flex align-items-start justify-content-between mb-3">
        <Skeleton width="55%" height="0.8rem" />
        <Skeleton width={46} height={46} circle />
      </div>
      <Skeleton width="40%" height="2rem" className="mb-3" />
      <Skeleton width="50%" height="0.75rem" />
    </div>
  );

  if (!withGrid && count === 1) {
    return card;
  }

  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div className="col-xl-3 col-md-6" key={index}>
          {card}
        </div>
      ))}
    </>
  );
};

export default CardSkeleton;
